
import React from "react";
import { Link } from "react-router-dom";

const Hero: React.FC = () => {
  // Add console log to track component rendering
  React.useEffect(() => {
    console.log("Hero component mounted");
    
    return () => {
      console.log("Hero component unmounted");
    };
  }, []);
  
  return (
    <section className="pt-16 pb-20 md:pt-20 md:pb-28" id="hero-section-main">
      <div className="container-custom">
        <div className="grid grid-cols-1 gap-12 items-center justify-center text-center">
          {/* ———— Content column ———— */}
          <div className="animate-fade-in-up mx-auto max-w-3xl">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-techne-primaryPurple leading-tight mb-6">
              Empower Your Board with AI Governance Training &amp; Frameworks
            </h1>

            <h2 className="text-2xl md:text-3xl text-gray-600 font-medium mb-4">
              Hands-On Programs and Proven Structures for Responsible AI Oversight
            </h2>

            <p className="text-lg text-techne-gray mb-8">
              Equip your directors with interactive training modules and customizable governance 
              frameworks that are designed to build AI literacy, ensure compliance, and embed 
              best-practice oversight across your organization.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/quiz"
                className="btn-primary text-lg px-6 py-3 text-center whitespace-normal"
              >
                Board Readiness Assessment
              </Link>

              <Link
                to="/blueprint"
                className="btn-outline text-lg px-6 py-3 text-center whitespace-normal"
              >
                Join December 1, 2025 Cohort
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
